<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['ecm-list-doc', getSelectedDEV && 'dev-selected-component']">
    <v-data-table v-model="selected" :headers="headers" :items="items" item-key="id" :search="search"
      v-bind="schema.attributesTable">
      <template v-slot:top>
        <v-card-title class="pt-1 elevation-0">
          <span v-if="schema.attributes.title" v-text="schema.attributes.title"></span>

          <v-spacer></v-spacer>

          <v-text-field clearable v-model="search" append-icon="search" label="Pesquisar..." single-line
            hide-details></v-text-field>
        </v-card-title>

        <v-divider></v-divider>

        <div v-bind="actionsECM.attributes">
          <template v-for="(actionEcm, index) in actionsECM.items">
            <v-tooltip
              v-if="actionEcm.id === 'btn_ecm_download_selected_document' ? (actionEcm.visible && selected.length) : actionEcm.visible"
              v-bind="actionEcm.tooltip?.attributes"
              :disabled="!actionEcm.tooltip?.label || !actionEcm.tooltip?.label === ''"
              :key="index"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="[actionEcm.attributes, attrs]"
                  :disabled="disableActions"
                  @click="actionExecuteById(actionEcm.id)"
                >
                  <v-icon
                    v-bind="[actionEcm.attributesIcon]"
                    v-if="actionEcm.attributesIcon?.icon"
                  >
                    {{ actionEcm.attributesIcon?.icon }}
                  </v-icon>
                  {{ actionEcm.label }}
                </v-btn>
              </template>
              <span>
                {{ actionEcm.tooltip?.label }}
              </span>
            </v-tooltip>
          </template>
        </div>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div class="d-flex justify-center table-actions">

          <v-tooltip
            v-if="customRecordingAction.editItem.visible"
            v-bind="customRecordingAction.editItem.tooltip.attributes"
            :disabled="!customRecordingAction.editItem.tooltip?.label || !customRecordingAction.editItem.tooltip?.label === ''"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :data-has-tooltip="customRecordingAction.editItem.tooltip.label ? 'true' : 'false'"
                :data-tooltip="customRecordingAction.editItem.tooltip.label"
                v-bind="[attrs, customRecordingAction.editItem.attributes]"
                v-on="on"
                @click="openModal('edit', item)"
              >
                {{ customRecordingAction.editItem.icon }}
              </v-icon>
            </template>
            <span>{{ customRecordingAction.editItem.tooltip.label }}</span>
          </v-tooltip>

          <v-tooltip
            v-if="customRecordingAction.getItem.visible"
            v-bind="customRecordingAction.getItem.tooltip.attributes"
            :disabled="!customRecordingAction.getItem.tooltip?.label || !customRecordingAction.getItem.tooltip?.label === ''"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :data-has-tooltip="customRecordingAction.getItem.tooltip.label ? 'true' : 'false'"
                :data-tooltip="customRecordingAction.getItem.tooltip.label"
                v-bind="[attrs, customRecordingAction.getItem.attributes]"
                v-on="on"
                @click="download(item)"
              >
                {{ customRecordingAction.getItem.icon }}
              </v-icon>
            </template>
            <span>{{ customRecordingAction.getItem.tooltip.label }}</span>
          </v-tooltip>

          <v-tooltip
            v-if="customRecordingAction.deleteItem.visible"
            v-bind="customRecordingAction.deleteItem.tooltip.attributes"
            :disabled="!customRecordingAction.deleteItem.tooltip?.label || !customRecordingAction.deleteItem.tooltip?.label === ''"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :data-has-tooltip="customRecordingAction.deleteItem.tooltip.label ? 'true' : 'false'"
                :data-tooltip="customRecordingAction.deleteItem.tooltip.label"
                v-bind="[attrs, customRecordingAction.deleteItem.attributes]"
                v-on="on"
                @click="deleteItem(item)"
              >
                {{ customRecordingAction.deleteItem.icon }}
              </v-icon>
            </template>
            <span>{{ customRecordingAction.deleteItem.tooltip.label }}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:[`item.saveDate`]="{ item }">
        {{ item.saveDate }}
      </template>
    </v-data-table>

    <div class="list-images-gallery"></div>

    <v-navigation-drawer
      app
      width="auto"
      right
      v-model="showDialog"
      temporary
      :permanent="schema.new?.attributes?.temporary ? false: showDialog"
      v-bind="schema.new?.attributes"
    >
      <div class="d-flex i4pro-ecm-drawer">
        <i4proMapDialog :dialogMap="dialog" @close="closeModalMap" :schema="mapConfig" @coords="schemaMap($event)" />
        <v-card class="i4pro-ecm-drawer__card" flat>
          <v-toolbar rounded="0" flat dark color="primary">
            <v-toolbar-title v-text="titleDialog()"></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items v-if="schema.new?.actions?.position === 'top' || !schema.new?.actions?.position">
              <v-btn dark text @click="saveDocuments" :disabled="!isValid && !readOnly">{{
                readOnly ? 'Alterar' : 'Salvar'
              }}</v-btn>
              <v-btn icon dark @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container class="mt-5" style="position: relative;">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="document.id_document_group"
                  :items="id_document_group_items"
                  item-text="documentGroupName"
                  item-value="idDocumentGroup"
                  :label="documentFields?.id_document_group?.label"
                  @change="handleId_document_group"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="document.id_tp_document"
                  :items="id_tp_document_items"
                  item-text="documentTypeName"
                  item-value="idDocumentType"
                  :label="documentFields?.id_tp_document?.label"
                  @change="handleId_tp_document"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="document.id_tp_dom_document"
                  :items="id_tp_dom_document_items"
                  item-text="domTypeDocumentName"
                  item-value="idDomTypeDocument"
                  :label="documentFields?.id_tp_dom_document?.label"
                  @change="handleId_tp_dom_document($event)"
                ></v-select>
              </v-col>

              <v-container v-if="typeGeolocation || geoEditMode">
                <h3>Geolocalização</h3>

                <img v-if="pathImgLocation" :src="pathImgLocation" alt="imagem" />

                <v-text-field v-model="document.geoCoordinates" readonly label="Coordenadas do mapa">
                  <template v-if="!readOnly" v-slot:append>
                    <v-tooltip color="primary" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" @click="openDialogMap">room</v-icon>
                      </template>
                      <span>Obter o mapa</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-text-field v-model="document.geoArea" readonly label="Área (m²)"></v-text-field>

                <v-text-field v-model="document.geoPerimeter" readonly label="Perímetro (m)"></v-text-field>
              </v-container>

              <v-col cols="12" v-if="documentFields?.nr_reference?.visible">
                <v-text-field v-model="document.nr_reference" :label="documentFields?.nr_reference?.label"></v-text-field>
              </v-col>
              <v-col cols="12" v-if="documentFields?.dt_document?.visible">
                <v-menu v-model="datePickerMenu" transition="scale-transition" min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :label="documentFields?.dt_document?.label" :value="computedDateFormattedMomentjs" clearable readonly
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="document.dt_document" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" v-if="documentFields?.tag?.visible">
                <v-text-field v-model="document.tag" :label="documentFields?.tag?.label"></v-text-field>
              </v-col>
              <v-col cols="12" v-if="documentFields?.observation?.visible">
                <v-textarea
                  counter
                  v-model="document.observation"
                  :label="documentFields?.observation?.label"
                  :rules="[maxCaracterObservation]"
                >
                </v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="readOnly">
              <v-col cols="12">
                <v-hover v-slot:default="{ hover }" v-if="document.content">
                  <v-card :elevation="hover ? 12 : 2" width="250" dark color="primary">
                    <v-img :src="document.content">
                      <v-row v-if="hover" align="center" justify="center" class="hover-card-image">
                        <v-col cols="12">
                          <v-card-text class="text-h5 font-weight-bold">Arquivo</v-card-text>
                          <v-card-text>{{ document.fileName }}</v-card-text>
                          <v-card-text class="font-weight-bold">{{ document.kBytesNumber }}</v-card-text>
                        </v-col>
                      </v-row>
                    </v-img>
                  </v-card>
                </v-hover>

                <v-card v-else min-width="250" dark color="primary">
                  <v-card-title class="text-center">
                    <v-tooltip bottom color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon :data-has-tooltip="document.fileName ? 'true' : 'false'" :data-tooltip="document.fileName"
                          large left v-on="on" v-bind="attrs">{{ document.contentType }}</v-icon>
                      </template>
                      <span>{{ document.fileName }}</span>
                    </v-tooltip>
                    <span class="text-h6 font-weight-light">{{ document.kBytesNumber }}</span>
                  </v-card-title>
                  <v-card-text class="font-weight-bold">{{ document.fileName }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" v-if="!typeGeolocation">
                <i4pro-file-upload-list :id="schema.id" v-if="showDialog" @add-file="addFile" @remove-file="removeFile"
                  :attributes="schema.attributesFiles"></i4pro-file-upload-list>
              </v-col>
            </v-row>

            <v-spacer></v-spacer>
            <v-row
              v-if="schema.new?.actions?.position === 'bottom'"
              class="mt-4"
              :style="schema.new?.actions?.sticky && `position: sticky; bottom: ${schema.new?.actions?.stickyBottom ? schema.new?.actions?.stickyBottom : '0px'}`"
            >
              <v-col
                cols="12"
                v-bind="schema.new?.actions?.attributes"
                :class="schema.new?.actions?.attributes?.class ? schema.new?.actions?.attributes?.class : 'd-flex gap-4'"
              >
                <v-btn
                  v-bind="schema.new?.actions?.customBtnSave?.attributes"
                  @click="saveDocuments"
                  :disabled="!isValid && !readOnly"
                >
                  <v-icon
                    v-if="schema.new?.actions?.customBtnSave?.attributesIcon"
                    v-bind="schema.new?.actions?.customBtnSave?.attributesIcon"
                  >
                    {{ schema.new?.actions?.customBtnSave?.attributesIcon?.icon }}
                  </v-icon>
                  {{
                    readOnly 
                      ? (schema.new?.actions?.customBtnSave?.labelEditDocument ? schema.new.actions.customBtnSave.labelEditDocument : 'Alterar' ) 
                      : (schema.new?.actions?.customBtnSave?.labelNewDocument ? schema.new.actions.customBtnSave.labelNewDocument : 'Salvar' )
                  }}
                </v-btn>

                <v-btn
                  v-bind="schema.new?.actions?.customBtnClose?.attributes"
                  @click="closeModal"
                >
                  <v-icon
                    v-if="schema.new?.actions?.customBtnClose?.attributesIcon"
                    v-bind="schema.new?.actions?.customBtnClose?.attributesIcon"
                  >
                    {{ schema.new?.actions?.customBtnClose?.attributesIcon?.icon }}
                  </v-icon>
                  {{
                    schema.new?.actions?.customBtnClose?.label
                      ? schema.new?.actions?.customBtnClose?.label
                      : 'Fechar modal' 
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </div>
    </v-navigation-drawer>
  </div>
</template>


<script>
import ECM from '@/services/ecm';
import { abstractField } from 'vue-form-generator';
import { getIcon, formatBytes, downloadFile } from '@/helpers/utils';
import Swal from 'sweetalert2';
import moment from 'moment';
import devComponentMixin from '@/mixins/dev-component-mixin';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

export default {
  mixins: [abstractField, devComponentMixin],

  components: {
    i4proFileUploadList: () => import('@/components/inputs/i4pro-file-upload-list'),
    i4proMapDialog: () => import('@/components/maps/i4pro-map-dialog')
  },

  data() {
    return {
      lightbox: null,
      dialog: false,
      datePickerMenu: false,
      showDialog: false,
      isValid: false,
      isValidRulesFields: true,
      search: '',
      selected: [],
      EcmKey: '',
      readOnly: false,
      disableActions: true,
      geoEditMode: true,
      urlImage: null,
      map: {
        coords: [],
        area: null,
        perimeter: null
      },
      mapConfig: {
        coords: [],
        area: null,
        perimeter: null
      },
      headers: [
        { text: 'Grupo', value: 'groupName', align: 'left', sortable: true, visible: true },
        { text: 'Tipo', value: 'documentType', sortable: true, visible: true },
        { text: 'Nome', value: 'documentFile', sortable: true, visible: true },
        { text: 'Tamanho', value: 'kBytesNumber', sortable: true, visible: true },
        { text: 'Data Gravação', value: 'saveDate', sortable: true, visible: true },
        { text: '', value: 'action', sortable: false }
      ],
      items: [],
      id_document_group_items: [],
      id_tp_document_items: [],
      id_tp_dom_document_items: [],
      tp_dom_document: null,
      document: {
        id_document_group: '',
        id_tp_document: '',
        id_tp_dom_document: '',
        nr_reference: '',
        dt_document: '',
        tag: '',
        observation: '',
        geoCoordinates: '',
        geoArea: '',
        geoPerimeter: '',
        files: []
      },
      documentFields: null,
      actionsECM: {
        attributes: {
          class: "pa-4 d-flex"
        },
        items: [
          {
            attributes: {
              class: "mr-2 mt-3",
              small: true,
              color: "primary"
            },
            attributesIcon: {},
            id: "btn_ecm_view_all_documents",
            label: "Visualizar todos",
            name: "btn_ecm_view_all_documents",
            visible: true,
            tooltip: {
              label: "",
              attributes: {
                color: "primary",
                bottom: true
              }
            }
          },
          {
            attributes: {
              class: "mr-2 mt-3",
              small: true,
              color: "primary"
            },
            attributesIcon: {
              icon: "add"
            },
            id: "btn_ecm_upload_new_document",
            label: "Novo",
            name: "btn_ecm_upload_new_document",
            visible: true,
            tooltip: {
              label: "",
              attributes: {
                color: "primary",
                bottom: true
              }
            }
          },
          {
            attributes: {
              class: "mr-5 mt-3",
              small: true,
              color: "primary"
            },
            attributesIcon: {},
            id: "btn_ecm_download_selected_document",
            label: "Baixar Selecionados",
            name: "btn_ecm_download_selected_document",
            visible: true,
            tooltip: {
              label: "",
              attributes: {
                color: "primary",
                bottom: true
              }
            }
          },
        ]
      },
      customRecordingAction: {
        editItem: {
          icon: "edit",
          visible: true,
          attributes : {
            size: "20",
            color: "green",
            class: "mr-2"
          },
          tooltip: {
            label: "Editar Documento ECM",
            attributes: {
              color: "green",
              bottom: true
            }
          },
        },
        getItem: {
          icon: "get_app",
          visible: true,
          attributes : {
            size: "20",
            color: "blue",
            class: "mr-2"
          },
          tooltip: {
            label: "Baixar documento ECM",
            attributes: {
              color: "blue",
              bottom: true
            }
          }
        },
        deleteItem: {
          icon: "delete_outline",
          visible: true,
          attributes : {
            size: "20",
            color: "red darken-3",
          },
          tooltip: {
            label: "Excluir documento ECM",
            attributes: {
              color: "red darken-3",
              bottom: true
            }
          }
        },
      },

      maxCaracterObservation: v => {
        return this.setCharacterLimit(v, 3000);
      },
    };
  },

  watch: {
    showDialog(val) {
      if (!val) {
        this.dialog = false;
      }
    },

    async pathImgLocation(newValue) {
      let file;
      const fileName = 'mapa.jpg';

      await fetch(newValue).then(async response => {
        const contentType = response.headers.get('content-type');
        const blob = await response.blob();
        file = new File([blob], fileName, { type: contentType });
      });

      this.document.files.push(file);
      this.handleIsValid();
    }
  },
  
  created() {
    this.customizeHeaders();
    this.customizeActionsECM();
    this.customizeRecordActions();
  },

  async mounted() {
    this.customizeDocumentsFields();
    const { data } = await ECM.GetKey(this.schema.domain ? this.schema.domain : this.model.id_dominio);

    this.EcmKey = data;

    if (this.model[this.EcmKey]) {
      this.getDocuments();

      this.disableActions = false;
    }
  },

  beforeDestroy() {
    if (this.lightbox) {
      this.lightbox.destroy();
    }
  },

  computed: {
    computedDateFormattedMomentjs() {
      return this.document.dt_document ? moment(this.document.dt_document).format('DD/MM/YYYY') : '';
    },

    typeGeolocation() {
      if (
        this.id_tp_dom_document_items.length > 0 &&
        this.id_tp_dom_document_items[0].idDomTypeDocument === 2 &&
        this.tp_dom_document === 2
      ) {
        return true;
      } else {
        this.geoEditMode = false;
        return false;
      }
    },

    pathImgLocation() {
      if (this.map.coords.length > 0) {
        const path = this.map.coords.join('|');
        this.urlImage = `https://maps.googleapis.com/maps/api/staticmap?&zoom=17&size=400x400&path=color:0x00000000|weight:5|fillcolor:0xf00000|${path}&key=AIzaSyBtyk6CLEKfxN5v1yFBLC9XJMO4O07xTYU`;

        return this.urlImage;
      } else {
        return null;
      }
    }
  },

  methods: {
    customizeHeaders() {
      // Verifica se contém especificação via JSON para retro-compatibilidade
      if (this.schema.headers) {
        const defaultHeadersValues = ['groupName', 'documentType', 'documentFile', 'kBytesNumber', 'saveDate', 'action'];
        // Caso tenha novas colunas além das 'defautlHeaders'
        let newColumnsValue = this.schema.headers?.filter ( customHeader => !(defaultHeadersValues.includes(customHeader.value)) );

        // Realiza o merge das propriedades para customizar as colunas 'defaultHeaders'
        this.headers.forEach( (defaultHeader, index) => {
          let objJSON = this.schema.headers?.find( customHeader => customHeader.value === defaultHeader.value );

          // Realiza o merge apenas nas colunas que possuem values diferentes da 'defaultHeaders'
          if( !(_.isEqual(defaultHeader, objJSON)) ) {
            _.merge(this.headers[index], objJSON)
          }
        })

        // Adiciona as novas colunas para renderizar na lista. Mantendo o indice especificado via JSON
        newColumnsValue?.forEach( newColumn => {
          let index = this.schema.headers?.findIndex( newHeader => newHeader.value === newColumn.value )
          
          if (index) {
            this.headers.splice(index, 0, newColumn)
          }
        });
      }

      // Caso algum Header esteja com VISIBLE: false
        // Não renderiza em tela.
      this.headers.forEach( (header, index) => {
        if (!header.visible) {
          this.headers.splice(index, 1)
        }
      } )
    },

    customizeActionsECM() {
      // Modo LIST só pode conter as action default, e seus IDs não podem ser sobreescritos
      this.schema.actionsECM?.items.map( action => {
        if (action.id) { delete action.id }
      });

      // Aplica merge nas actions default para aplicar customização
      _.merge(this.actionsECM, this.schema.actionsECM);
    },

    customizeRecordActions() {
      const oldAttributesRecordActions = ['tooltipExcludeItem', 'tooltipGetItem', 'tooltipEditItem', 'excludeItem']
      const customRecordActionJSON = this.schema.attributes;

      // Copia os attributos padrões previstas
      const objToMerged = structuredClone(this.customRecordingAction)
      // Prepara os atributos vindo do JSON
      const objCustomAttributes = {
        editItem: this.schema.attributes?.editItem,
        getItem: this.schema.attributes?.getItem,
        deleteItem: this.schema.attributes?.deleteItem 
      };

      // Realiza o Merge já com as customizações
      _.merge(objToMerged, objCustomAttributes)

      // Verifica se é necessário retro-compatibilidade
        // Em versões antigas do ECM os atributos de customização era fora do padrão
      if (oldAttributesRecordActions.some(item => Object.keys(customRecordActionJSON).includes(item))) {
        let keysToNode = {
          'editItem': this.schema.attributes.tooltipEditItem,
          'getItem': this.schema.attributes.tooltipGetItem,
          'deleteItem': this.schema.attributes.tooltipExcludeItem
        }

        // Prepara o objeto a ser mergado na estrutura correta
        Object.keys(objToMerged).map( recordAction => {
          objToMerged[recordAction].tooltip.label = (keysToNode[recordAction] || objToMerged[recordAction].tooltip.label)

          if (recordAction === 'deleteItem') {
            objToMerged[recordAction].visible = (this.schema.attributes.excludeItem || objToMerged[recordAction].visible)
          }
        })
      }

      // Realiza o Merge para renderização em tela
      _.merge(this.customRecordingAction, objToMerged)
    },

    // Customiza os Campos do SIDEBAR para Alterar/Salvar um documento.
    customizeDocumentsFields() {
      this.documentFields = structuredClone(this.document);

      // Popula as propriedades com a configuração padrão
      const defaultLabels = {
        'id_document_group': 'Grupo de documento',
        'id_tp_document': 'Tipo de documento',
        'id_tp_dom_document': 'Tipo dom de documento',
        'nr_reference': 'Número de referência',
        'dt_document': 'Data do documento',
        'tag': 'Tag',
        'observation': 'Observação'
      }
      const fieldsNotCustomization = ['geoCoordinates', 'geoArea', 'geoPerimeter', 'files']

      // Prepara as configuração padrão para retro-compatibilidade
      Object.keys(this.documentFields).forEach(key => {
        if (fieldsNotCustomization.some( IdNotAllows => key === IdNotAllows )) return;

        // Preenche o campo LABEL e VISIBLE (em campos que não são obrigatórios)
        this.documentFields[key] = { label: defaultLabels[key] }
        if (key !== 'id_document_group' && key !== 'id_tp_document' && key !== 'id_tp_dom_document') {
          this.documentFields[key] = { ...this.documentFields[key], visible: true } 
        }
      });

      // Caso tenha customização via JSON, realiza o merge para renderizar em tela
      if (this.schema.new?.documentFields) {
        _.merge(this.documentFields, this.schema.new.documentFields);
      };
    },

    schemaMap(event) {
      this.map.coords = [];
      event.coordsMap[0].map(c => {
        let item = `${c.lat()}, ${c.lng()}`;
        this.map.coords.push(item);
      });

      this.mapConfig = {
        coords: event.coordsMap,
        area: event.area,
        perimeter: event.perimeter
      };

      const coordsString = this.map.coords.toString();

      this.document.geoCoordinates = coordsString;
      this.document.geoArea = event.area;
      this.document.geoPerimeter = event.perimeter;

      event.coordsMap = [];
    },

    actionExecuteById (actionEcmId) {
      if (actionEcmId === 'btn_ecm_view_all_documents') {
        this.openImagesGallery()
      } else if (actionEcmId === 'btn_ecm_upload_new_document') {
        this.openModal('new')
      } else if (actionEcmId === 'btn_ecm_download_selected_document') {
        this.downloadItems()
      }
    },

    validateShowAction (actionEcm) {
      if (actionEcm.id === 'btn_ecm_download_selected_document') {
        return actionEcm.visible && this.selected.length
      }

      return actionEcm.visible
    },

    openDialogMap() {
      this.dialog = true;
    },

    async handleId_document_group() {
      const { data } = await ECM.GetDocumentType(this.document.id_document_group);

      this.id_tp_document_items = data;
      this.document.id_tp_document = '';
      this.document.id_tp_dom_document = '';

      this.handleIsValid();
    },

    async handleId_tp_document() {
      const { data } = await ECM.GetDomDocumentType(this.document.id_tp_document);

      this.id_tp_dom_document_items = data;
      this.document.id_tp_dom_document = '';

      this.handleIsValid();
    },

    async deleteItem(item) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: `v-btn v-size--default primary`,
          cancelButton: `v-btn v-size--default error`
        },
        buttonsStyling: false
      });

      const result = await swalWithBootstrapButtons.fire({
        title: 'Deseja realmente excluir esse documento?',
        text: '',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      });

      if (result.value) {
        try {
          const { data } = await ECM.DeleteDocument(this.getHash(item));
          await this.getDocuments();

          if(data.length > 0){
            if('message' in data[0]){
              this.$store.dispatch('notification/showNotification', {
              color: 'alert',
              text: data[0].message,
              showIconNotification: false
          });

          return;
          }
          }
          this.$store.dispatch('notification/showNotification', {
            color: 'success',
            text: 'Documento excluído com sucesso',
            showIconNotification: false
          });

        } catch (err) {
          this.$store.dispatch('notification/showNotification', {
            color: 'error',
            text: err,
            showIconNotification: false
          });
        }
      }
    },

    async download(item) {
      const { data } = await ECM.DownloadDocument(this.getHash(item));

      if (data) {
        downloadFile(data.content, data.contentType, data.fileName.split('.').pop(), data.fileName.split('.').shift());
      }
    },

    async downloadItems() {
      const { data } = await ECM.DownloadDocuments(this.selected.map(item => this.getHash(item)));

      if (data) {
        downloadFile(data.content, data.contentType, data.fileName.split('.').pop(), data.fileName.split('.').shift());
      }
    },

    async getDocuments() {
      const { data } = await ECM.GetDocuments(this.schema.domain ? this.schema.domain : this.model.id_dominio, this.schema.id_tp_document ? this.schema.id_tp_document : this.model.id_tp_documento, this.model[this.EcmKey]);
      
      for (let item in data) {
        data[item].saveDate = this.formatDate(data[item].saveDate);
        data[item].kBytesNumber = formatBytes(data[item].kBytesNumber);
        data[item].tag = this.formatTag(data[item].tag);
      }

      this.items = data;

      if (this.items.length > 0) {
        const galleryContainer = document.querySelector('.list-images-gallery');
        galleryContainer.innerHTML = ''

        this.items.forEach(async item => {
          if (item.contentType.startsWith('image')) {
            let anchor = document.createElement('a');
            anchor.id = item.id;
            anchor.setAttribute('hash', item.hash);
            const { data: dataImage, status } = await ECM.ReturnImageContent(this.getHash(item));
            if (status !== 200 && status !== 204) return;
            anchor.href = dataImage;

            galleryContainer.appendChild(anchor);
          }
        });

        this.initializePhotoSwipe();
      }
    },

    initializePhotoSwipe() {
      if (this.lightbox) {
        this.lightbox.destroy();
      }

      // Aguarda o carregamento completo das imagens antes de inicializar o PhotoSwipe
      const galleryContainer = document.querySelector('.list-images-gallery');
      const imageElements = galleryContainer.querySelectorAll('a');

      const promises = Array.from(imageElements).map(anchor => {
        return new Promise(resolve => {
          const img = new Image();
          img.src = anchor.href;
          img.onload = () => {
            anchor.setAttribute('data-pswp-width', img.width);
            anchor.setAttribute('data-pswp-height', img.height);
            resolve();
          };
        });
      });

      Promise.all(promises).then(() => {
        // Inicializa o PhotoSwipe após todas as imagens terem sido carregadas
        this.lightbox = new PhotoSwipeLightbox({
          gallery: '.list-images-gallery',
          children: 'a',
          imageClickAction: 'none',
          wheelToZoom: true,
          clickToCloseNonZoomable: false,
          showHideAnimationType: 'fade',
          pswpModule: () => import('photoswipe'),
        });

        this.lightbox.on('imageClickAction', (e) => {
          if (e.originalEvent?.srcElement?.currentSrc) {
            window.open(e.originalEvent.srcElement.currentSrc, '_blank');
          }
        });

        this.lightbox.init();
      })
    },

    openImagesGallery() {
      if (this.lightbox && this.items.length > 0) {
        this.lightbox.loadAndOpen(0);
      }
    },

    async openModal(mode, item) {
      const { data: dataGetDocumentGroup } = await ECM.GetDocumentGroup(this.schema.domain ? this.schema.domain : this.model.id_dominio);
      this.id_document_group_items = dataGetDocumentGroup;

      if (mode === 'edit') {
        this.geoEditMode = true;
        const { data: dataGetDocumentDetail } = await ECM.GetDocumentDetail(this.getHash(item));

        this.document.id_document_group = dataGetDocumentDetail.idDocumentGroup;
        await this.handleId_document_group();

        this.document.id_tp_document = dataGetDocumentDetail.idDocumentType;
        await this.handleId_tp_document();

        this.document.id_tp_dom_document = dataGetDocumentDetail.idDocumentDomainType;
        this.document.nr_reference = dataGetDocumentDetail.referenceNumber;
        this.document.dt_document = dataGetDocumentDetail.documentDate;
        this.document.tag = dataGetDocumentDetail.tagName;
        this.document.observation = dataGetDocumentDetail.observation;
        this.document.contentType = this.setIcon(dataGetDocumentDetail.contentType);
        this.document.fileName = dataGetDocumentDetail.fileName;
        this.document.kBytesNumber = formatBytes(dataGetDocumentDetail.kBytesNumber);
        this.document.geoCoordinates = dataGetDocumentDetail.geoCoordinates;
        this.document.geoArea = dataGetDocumentDetail.geoArea;
        this.document.geoPerimeter = dataGetDocumentDetail.geoPerimeter;
        this.document.documentId = item.id;
        this.document.documentHash = this.getHash(item);
        this.document.hash = item.hash;
        this.readOnly = true;
        this.geoEditMode = item.geoCoordinates.length > 0;

        if (dataGetDocumentDetail.contentType.startsWith('image')) {
          const { data: dataReturnImageContent } = await ECM.ReturnImageContent(this.getHash(item));
          this.document.content = dataReturnImageContent;
        }
      }

      this.showDialog = true;
    },

    async save() {
      const { login } = await this.$store.getters['authentication/getUserProfile'];
      const { status } = await ECM.InsertDocument(this.document, this.schema.domain ? this.schema.domain : this.model.id_dominio, this.model[this.EcmKey], login);

      if (status === 200 || status === 204) {
        await this.getDocuments();

        this.$store.dispatch('notification/showNotification', {
          color: 'success',
          text: 'Documentos adicionados com sucesso',
          showIconNotification: false
        });
      }

      this.closeModal();
    },

    async update() {
      const { status } = await ECM.UpdateDocument(this.document);

      if (status === 200 || status === 204) {
        await this.getDocuments();

        this.$store.dispatch('notification/showNotification', {
          color: 'success',
          text: 'Documento alterado com sucesso',
          showIconNotification: false
        });
      }

      this.closeModal();
    },

    async saveDocuments() {
      if (this.documentFields?.observation?.visible && !this.isValidRulesFields) {
        this.$store.dispatch('notification/showNotification', { color: 'red', text: 'Verifique se todos os campos foram preenchidos corretamente!', showIconNotification: false });
        return;
      } 
      if (this.readOnly) this.update();
      else this.save();
    },

    handleId_tp_dom_document(event) {
      this.tp_dom_document = event;
      this.handleIsValid();
    },

    handleIsValid() {
      if (
        this.document.id_document_group &&
        this.document.id_tp_document &&
        this.document.id_tp_dom_document &&
        this.document.files.length > 0
      )
        this.isValid = true;
      else this.isValid = false;
    },

    clearDocumentItems() {
      this.id_document_group_items = [];
      this.id_tp_dom_document_items = [];
      this.id_tp_document_items = [];
    },

    clearDocument() {
      this.document = {
        id_document_group: '',
        id_tp_document: '',
        id_tp_dom_document: '',
        nr_reference: '',
        dt_document: '',
        tag: '',
        observation: '',
        files: []
      };
    },

    closeModal() {
      this.clearDocumentItems();
      this.clearDocument();
      this.tp_dom_document = null;
      this.showDialog = false;
      this.dialog = false;
      this.isValid = false;
      this.readOnly = false;
      this.map.coords = [];
      this.map.area = null;
      this.map.perimeter = null;
      this.mapConfig = {};
      this.geoEditMode = false;
      this.urlImage = null;
    },

    closeModalMap() {
      this.dialog = false;
    },

    setIcon(type) {
      return getIcon(type);
    },

    getHash(item) {
      let hash = item.id.toString().padStart(9, '0');

      return `${hash}${item.keyValues}`;
    },

    addFile(items) {
      this.document.files = items;
      this.handleIsValid();
    },

    removeFile(items) {
      this.document.files = items;
      this.handleIsValid();
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },

    formatTag(tags) {
      return tags ? tags.toLocaleString() : '';
    },

    titleDialog() {
      let titleEdit = this.schema.attributes.titleDialogEdit || 'Editar Documento ECM';
      let titleNew = this.schema.attributes.titleDialogNew || 'Novo Documento ECM';

      return this.readOnly ? titleEdit : titleNew;
    },

    setCharacterLimit(v, max) {
      if (v === null || v === undefined || v === '' || v.length === 0) return true;

        if (v.length > max) {
          this.isValidRulesFields = false;
          return `Máximo ${max} Caracteres!`;
        }
        this.isValidRulesFields = true;
        return true;
    },
  }
};
</script>

<style>
.pswp__item .pswp__img {
  cursor: pointer !important;
}
</style>

<style lang="scss" scoped>
.v-responsive__content {
  transition: 300ms;

  .hover-card-image {
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.6);
    transition: 300ms;

    div {
      color: #fff;
      text-align: center;
      padding: 0 0 10px 0;
    }
  }
}

.ecm-list-doc {
  position: relative;
}

.btn-close {
  position: absolute;
  top: 51%;
  right: 30px;
  color: var(--v-error-darken2);
  font-size: 30px;
  cursor: pointer;
  font-size: 24px !important;
  z-index: 100;
  opacity: 0;
}

.table-actions {
  i {
    font-size: 20px !important;
  }
}

.list-images-gallery {
  display: none;
}

@keyframes opacity {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.i4pro-ecm-drawer {
  &__card {
    width: 500px;
  }
}
</style>
